/**
 * v6 API return code 的對照表
 * 每一個模組間隔 10000
 */

/**
 *
 * @param {number} codeReminder
 * @param {number} nmultipleum
 * @returns returnCode: number
 */
function setCode(codeReminder, multiple = 1) {
  return multiple * 1000000 + codeReminder;
}

export const API_RETURN_CODE = {
  success: 0,
  common: {
    success: 0,
  },
  admin: {
    unauthorized: setCode(0),
    planExpired: setCode(1),
    exceedPlanParticipantMaximum: setCode(2),
    exceedPlanStartupCodeMaximum: setCode(3),
    pointsNotEnough: setCode(4),
    loginFailure: setCode(6),
    tokenExpired: setCode(7),
    invalidToken: setCode(8),
  },
  module: {
    notFound: setCode(10000),
    maintenance: setCode(10004), // 維護中
  },
  event: {
    canNotCancelToPublishBecauseSold: setCode(20000),
    canNotCloseSignUpBecauseSold: setCode(20001),
    canNotDeleteEventBecausePublished: setCode(20002),
    prefixConflict: setCode(20003),
  },
  participant: {
    notIncludedDefaultColumns: setCode(30000), // 未包含預設欄位
    userIdIsDuplicated: setCode(30001), // ID 重複
    importTicketTypeNotFound: setCode(30002), // 找不到匯入票種
    exceedTicketTypeMaximum: setCode(30003), // 人數超出票種上限
    columnsAndParticipantsAreNotConsistency: setCode(30004), // 名單與欄位不一致
    columnIdIsDuplicated: setCode(30005), // 欄位 id 重複
    columnsOutOfRange: setCode(30006), // 欄位超過上限 20 欄
    needToSameColumnsWhenIsSignUpActive: setCode(30007), // 報名表單開啟時，無法匯入欄位不同的名單
    eachLangSameColumnsAmount: setCode(30009), // 不同語系欄位數量不一致(各語系欄位數量應一致)
  },
  signUp: {
    ticketIsNotPermitted: setCode(40000), // 票券已被刪除或完成報名
    eventIsNotActive: setCode(40001), // 活動尚未發布
    signUpFormIsNotActive: setCode(40002), // 報名表單尚未開啟
    ticketIsNotActive: setCode(40003), // 票券尚未販售
    ticketisNotSoldPeriod: setCode(40004), // 票券尚不能購買
    ticketIsSoldOut: setCode(40005), // 票券無庫存
    noChooseAnyTicketTypes: setCode(40006), // 未指定購買票種
    unableToBuySession: setCode(40007), // 無法購買場次
    chooseSessionAmountNotAllowed: setCode(40008), // 自選場次數量不符
    sessionIsFull: setCode(40009), // 場次已額滿
    requiredFieldNotFilled: setCode(40010), // 必填欄位未填
    uniqueFieldValueDuplicated: setCode(40011), // 唯一欄位，欄位值重複
  },
  qrImage: {
    receiverKeysAreNull: setCode(50000), // ID 為空
    receiverKeysAreDuplicated: setCode(50001), // ID 重複
    receiverKeysAreNotValid: setCode(50002), // ID 不存在
    indexPageNotFound: setCode(500003), // 找不到來賓專屬頁面
  },
  email: {
    notFoundReceiver: setCode(80000), // 找不到收件人
    sentAlready: setCode(80001), // 已發送的信件
    invalidBcc: setCode(80002), // bcc 格式錯誤
  },
  sms: {
    sentAlready: setCode(90001), // 已發送的信件
  },
  indexPage: {
    isExist: setCode(100000), // 已經存在
    isNotActiveYet: setCode(100001), // 尚未開放
    participantNotFound: setCode(100002), // 找不到來賓
    invalidParticipant: setCode(100003), // 無效的來賓
    isNotActiveWthinTime: setCode(100004), // 未在開放時間內
    invalidUserCode: setCode(100005), // userCode 驗證失敗
    isNotOpenCode: setCode(100006), // 來賓專屬頁面不存在(未開啟)
  },
  session: {
    sortIdIsRepeat: setCode(110000), // sort ID 重複
    nameIsRepeat: setCode(110001), // 場次名稱重複
    sessionHaveBeenSold: setCode(110002), // 無法更新/刪除販售中票種關聯的場次
    sessionIsFull: setCode(110003), // 場次額滿
  },
  paymentSetting: {
    paymentSettingIsExist: setCode(140000), // 金流設定已存在 (已 POST 過)
    paymentNotSetting: setCode(140001), // 未設定金流
  },
  surveyForm: {
    isNotWithinTime: setCode(170000), // 未在開放時間內的問卷,
    isObtained: setCode(170001), // 已領取過問卷禮
    versionIsOutdated: setCode(170002), // 非最新版問卷
  },
  guest: {
    userCodeIsNull: setCode(180000), // userCode 空的
    userCodeUnauthenticated: setCode(180001), // userCode 驗證失敗
  },
  mailServerSetting: {
    mailServerSettingIsExist: setCode(190000), // 郵件伺服器設定已經存在 (曾 Creat 過)
    mailServerSettingNotExist: setCode(190001), // 未設定過郵件伺服器
  },
  familyDayForm: {
    familyDayFormIsExist: setCode(200000), // 家庭日表單已存在
    familyDayFormNotExist: setCode(200001), // 家庭日表單尚未設定過
  },
  redeemPrize: {
    prizeNotExist: setCode(210001), // 獎項不存在
    prizeTokenNotExist: setCode(210002), // 領獎token不存在
    prizeRedeemed: setCode(210003), // 獎項已領取
  },
};
